import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth62: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M52.8,84.5h53.5s-25.2-47.9-53.5,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '18.5 92.8 138.1 92.8 139.3 97.4 139.4 100.4 140.1 106.4 140.1 109.8 139.4 112.8 18 112.8 16.6 107.6 15.9 101.6 15.9 99.5 16.7 95.7 18.5 92.8',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.1,121.7l-8.2-5.5-3-3.3-1.9-6.6-.2-7.2,2.6-6.2,3.5-5,5-6.1s29.3,18.5,2.1,40h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.6,82.4l3.9,5.8,2.6,4.6,1.2,4.6.8,7v5.4l-1.3,8.1-4.1,6.6s-40-20.1-3.2-42h.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.4,109.8s47-29.9,121.5-5l-1.6-12.2-5.3-9.7-5.4-5.3-5.6-4.5-5.6-4.6-6.4-3.5-7.5-3.2-7-2.2-7.7-1.2-12.9-.4-11,1.2-6.6,2.2-7,2.9-6.6,4.6-6.2,4.3-6.2,3.7-4.9,4.6-4.3,4.9-3.2,5.9-2.2,5.5-.3,3.9,1.3,7.4.6.7h.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.4,109.8s46.8-30.1,121.5-5l-.3,10.5-2.6,7.3-3.7,5.2-7.2,7.7-5.1,5.3-8,7.6-6.3,3.6-6.8,2.4-5.4,1.4h-11.2l-10.5-2.8-8-3.8-8.1-5.6-7.5-8.4-8.3-6.3-9.4-5.2-9.1-6.2-4.5-5.9.3-1.9h.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.9,148.5c-8.2-3.8-11.9-13.8-26.1-21.5s-14.5-6.7-18.6-12.9c-6.1-9-2.9-20,2.8-28,4.9-6.9,11.9-10.1,18.1-15,11.9-9.4,24.8-12.9,39.8-12.7,18.9.3,35.5,7.3,48.5,21.2,6.1,6.6,9.6,13.2,10.5,22.4s-3.1,24.9-14.6,32.5c-7.8,11.8-20.8,20.3-35.3,20.9s-17-3.2-25.2-6.9Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '13.2 51.8 13.4 41.6 14.8 36.1 19.6 30.6 27.6 27.6 38 24.9 63.1 24.9 85.4 24.9 106.6 24.5 113.3 26.9 121.2 31 127.1 35.8 133.8 43.8 137.9 50.7 13.2 51.8',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.8,68.7l1.7,17.6,3.4,14.6s50.4-26.9-5.1-32.3h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M142.3,65.2l1.2,7.7v8.6l-.5,9.8-.7,5.3s-51.3-21.2,0-31.4Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M66.8,98.3A13.4,13.4 0 0 1 93.6,98.3A13.4,13.4 0 0 1 66.8,98.3Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,133.8s41.5,33.4,100.5,0l-5,11.7s-45.6,26.1-88.6,0l-6.9-11.7Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,133.8l-5-8.7-3.4-6.4-2.1-8-2.3-8.9-2.1-10.3-1.6-9.2-1.1-7.3-1.1-10.3v-24.5l1.6-4.8,4.1-4.4,5.3-2.3,7.8-2.1,7.3-1.6h13.5s8.7,83.6-20.8,108.8h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M133.1,133.8l4.8-14,3.4-13.5,1.6-8,1.1-11.9v-16l-2.3-10.5-4.4-8-4.4-8.2-6.2-7.3-8.9-7.1-8.7-2.7-7.6-1.4h-5.3s-.2,84.3,36.6,108.8l.3-.2Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,133.8l-8.5-15.1-2.1-8-2.3-8.9-2.1-10.3-1.6-9.2-1.1-7.3-1.1-10.3v-24.5l1.6-4.8,4.1-4.4,5.3-2.3,7.8-2.1,7.3-1.6h61.8l7.6,1.4,8.7,2.7,8.9,7.1,4.4,5.2,6.2,10.4,4.4,8,2.3,10.5v16l-1.1,11.9-1.6,8-3.4,13.5-4.8,14s-51.8,33.7-100.5,0h-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M133.1,132.7c-29,19.6-65.4,18.4-97.3,6.4-6.9-8.6-11-18.3-13.6-29.2-5-20.7-8.4-41.4-8.9-62.8s1.1-10.4,4.1-13.6c10-10.5,36.9-8.5,53.6-6.9,14.2,1.4,36.9-8.1,54.1,8.2,12.7,12,19.4,27.8,18.4,45.3-.9,17.7-2.4,36.4-10.4,52.7Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.1,421.4h59.1s-29.9-119.1-59.1,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.9,425.9l-2.4,28.9s48.1-15.7,2.4-28.9Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M146.3,427.4v13.2l-4.7,16.2s-49.4-21.7,4.7-29.4Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '138.4 463.6 14.7 463.6 16.4 472.2 21.7 479.4 29.1 484 43.2 487.2 56.2 488 69 488.2 82.1 487.4 98.3 487.2 108.6 486.1 121.5 482.5 129 476.5 135.8 468.4 138.4 463.6',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.2,365.7s36.8-33.8,94.4.5l-1.3-9.7s-47.9-36.9-92.1-.6l-1,9.8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.2,488h-9.7c0-.1-8-1.6-8-1.6l-6.6-2.2-5-2.5-3.5-3.7-3.4-4-1.8-4.3-1.5-5v-21.8l1.5-11.9,2.1-12.7,2.2-12.2,3.2-12.4,2.5-8.8,5.6-10.2,6.4-9s21.7,59,16,122.3Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.6,366.3l2,4.2,4.2,8.8,3.8,8.5,2.8,10.8,1.5,9.7.7,7.5v16.3c.1,0-.3,8.8-.3,8.8l-1.9,8-3.4,10.8-6.6,10.6-5.4,5.7-9.4,6.9-7.8,3.1-6.1.7s6.3-79.4,25.9-120.6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.6,366.3l2,4.9,4.8,9.2,2.4,5.8,3.8,11.1,1.5,11.3.3,10.9.5,8.7-.3,11.4-4.1,15.5-4.1,8.5-5.9,9.5-8.2,7.7-5.1,2.9-9.7,2.7-11.3,1.5-34.4.9h-11.3l-11.8-1.4-11.1-2.6-7.2-3.8-6.6-7.8-1.9-8.9.3-11.6.5-17.2,1.7-11.3,3.1-17.7,2.4-10.6,4.1-12.1,5.5-9.2,4.9-6.8.8-2.2s36.5-33.9,94.4.5Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M101.1,487.1l-36.9.9c-20.9.5-47.9-1.1-49.3-23.6s1.9-42.7,6.5-64c2.6-11.8,6.7-22.2,14.3-31.8,30.7-22.6,66.6-20.6,97.5,1.2l8.3,17.6c5,17.3,6.7,35.6,4.2,53.4-3.4,24.6-19.1,45.8-44.5,46.4Z',
			},
		},
	},
};
